import { useEffect, useState } from "react";
import { useRouter } from "easy-page-router/react";

type ReloadLineProps = {
    duration?: number,
    stopReload?: boolean,
    value: null | unknown,
    error: null | unknown,
    isLoading: boolean,
    onReload: () => void,
}

export function ReloadLine({ duration = 10, value, stopReload, error, isLoading, onReload }: ReloadLineProps) {
    const { state } = useRouter();
    const [animateStatus, setAnimateStatus] = useState<"wait" | "pre-load" | "pre-wait" | "loading" | "error" | "success">("loading");

    let status = animateStatus;
    if (isLoading) status = "loading";
    if (error) status = "error";
    if (stopReload) status = "success";

    useEffect(() => {
        if (state !== "active") {
            setAnimateStatus("pre-wait");
        }

        if (state === "active" && isLoading === false) {
            setAnimateStatus("pre-load");

            const handleReload = () => {
                setAnimateStatus("pre-wait");
            };

            const timeout = setTimeout(() => {
                handleReload();
            }, duration * 1000);

            const handleVisibilityChange = () => {
                if (document.visibilityState === "visible") {
                    handleReload();
                } else {
                    clearTimeout(timeout);
                }
            };

            document.addEventListener("visibilitychange", handleVisibilityChange);
            return () => {
                clearTimeout(timeout);
                document.removeEventListener("visibilitychange", handleVisibilityChange);
            };
        }
    }, [isLoading, value, state, duration]);

    useEffect(() => {
        if (state !== "active" || stopReload === true) return;

        if (animateStatus === "pre-load")
            requestAnimationFrame(() => {
                setAnimateStatus("wait");
            });

        if (animateStatus === "pre-wait")
            requestAnimationFrame(() => {
                setAnimateStatus("wait");
                onReload();
            });

    }, [animateStatus, state, stopReload]);

    return <div className={`reload-line ${status}`} style={status === "wait" ? { animationDuration: `${duration}s` } : {}} />;
}
